import styled from 'styled-components';
import GoalProgressCircle from 'challenge/common/GoalProgressCircle';

export const ProgressCircle = styled(GoalProgressCircle)`
  margin-top: -48px;
`;
